export function makeCommaDelimitedSentenceFragment(
	items: string[],
	useOxfordComma: boolean,
	finalItemPrefix: string
): string {
	if (arguments.length < 3) {
		finalItemPrefix = 'and';
	}

	if (items.length === 0) {
		return '';
	}
	else if (items.length === 1) {
		return items[0];
	}
	else if (items.length === 2) {
		return items[0] + ' ' + finalItemPrefix + ' ' + items[1];
	}
	else if (useOxfordComma && !finalItemPrefix) {
		return items.join(', ');
	}
	else {
		return items.slice(0, items.length - 1).join(', ') + (useOxfordComma ? ', ' : ' ') + (finalItemPrefix ? finalItemPrefix + ' ' : '') + items[items.length - 1];
	}
}

/**
 * Converts a camelCase or PascalCase string into a space-delimited string.
 */
export function addSpaces(casedString: string) {
	if (!casedString)
		return casedString;

	const regex = /(^[a-z]+|[A-Z]{2,}(?=[A-Z][a-z]|$)|[A-Z][a-z]*)/g;
	return casedString.match(regex)?.join(' ') ?? casedString;
}

/**
 * Converts a camelCase or PascalCase string to kebab-case.
 */
export function toKebabCase(value: string): string {
	return value.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
}

/**
 * Converts a string to title case, capitalizing the first letter of each word
 */
export function toTitleCase(input: string): string {
	if (!input)
		return input;

	return input.replace(/\w\S*/g, (txt) => {
		return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
	});
}